import { indoorCategoriesItemOffersAtom } from "@/atoms/indoor";
import { CategoryImageCard } from "@/components/home/CategoryImageCard";
import { Category } from "@/types";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";

/**
 * Category card of the CATEGORY_LIST indoor menu grid — same visual as the
 * delivery CategoryImages, sourced from the indoor atoms.
 */
export function MenuCategoryCard({ category }: { category: Category }) {
  const navigate = useNavigate();
  const categoriesItemOffers = useAtomValue(indoorCategoriesItemOffersAtom);

  return (
    <CategoryImageCard
      category={category}
      categoryItemOffers={categoriesItemOffers[category.id] ?? []}
      onClick={() => navigate(`/menu?category=${category.id}`)}
    />
  );
}
